module.exports = __webpack_public_path__ + "static/media/ios-share.14c727bf.svg";